import React from "react";
import Home from "./Home";
import About from "./About";
import Projects from "./Projects";
import Cp from "./Cp";
import Contact from "./Contact";
import Footer from "./Footer";
function App(){
    return (
        <div>
            <Home />
            <About />
            <Projects />
            <Cp />
            <Contact />
            <Footer />
        </div>
    )
}
export default App;
